import {
  Box,
  Button,
  Center,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { useTranslations } from 'next-intl';
import { create } from 'zustand';

import { useCardBindingStore } from './useCardBindingStore';

export const ToggleReminder = () => {
  const { isOpen } = useToggleReminderStore();
  const { isBind } = useCardBindingStore();
  const t = useTranslations();
  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={useToggleReminderStore.getState().close}
    >
      <ModalOverlay />
      <ModalContent p={0}>
        <ModalHeader>
          <Text
            bg="gradients.white-blue-title"
            bgClip="text"
            textStyle={{
              base: 'body1Bold',
              desktop: 'subtitle3',
            }}
          >
            {t('card.Remember the toggle')}
          </Text>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody
          p="6"
          pt="0"
          display="flex"
          flexDir="column"
          color="brand.white"
          gap="6"
        >
          <Center>
            <Box pos="relative">
              <Image
                src={getAssetUrl(
                  isBind
                    ? '/images/cdc-bind-card/cdc-enable-auto-2-new.png'
                    : '/images/cdc-bind-card/cdc-enable-auto-3-new.png',
                )}
                w="200px"
                alt="Auto Top-up"
                rounded="4px"
              />
            </Box>
          </Center>
          <Text textStyle="body2" textAlign="center">
            {isBind
              ? t.rich(
                  'card.Make sure to turn on the <b>auto top-up</b> toggle in the Crypto-com app',
                  {
                    b: (c) => (
                      <Text as="span" fontWeight="bold">
                        {c}
                      </Text>
                    ),
                  },
                )
              : t.rich(
                  'card.Make sure to turn off the <b>auto top-up</b> toggle in the Crypto-com app',
                  {
                    b: (c) => (
                      <Text as="span" fontWeight="bold">
                        {c}
                      </Text>
                    ),
                  },
                )}
          </Text>
          {isBind && (
            <Text textStyle="body2" textAlign="center">
              {t(
                'card.Otherwise, the funds will go to your Crypto-com wallet instead of your Crypto-com Card',
              )}
            </Text>
          )}
          <Button
            w="full"
            size="sm"
            variant="ghost"
            bgColor="#159DFF"
            rounded="4px"
            textTransform="unset"
            onClick={() => {
              useToggleReminderStore.getState().close();
              useCardBindingStore.getState().close();
            }}
          >
            {t('card.I understand')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export const useToggleReminderStore = create<{
  isOpen: boolean;
  open: () => void;
  close: () => void;
}>((set) => ({
  isOpen: false,
  open: () => {
    set({ isOpen: true });
  },
  close: () => {
    set({ isOpen: false });
  },
}));
